import { month, shortenedMonth } from './variables';
import CryptoJS from 'crypto-js';


/**
 * Untuk manual validation
 */

const manualValidation = (el) => {

  let curErr = 0

  el.each((ind, val) => {

    const curEl = $(val)

    if ((['INPUT', 'SELECT', 'TEXTAREA'].includes(curEl.prop('nodeName'))) && ((curEl.is(':visible') && !curEl.is(':disabled')))) {

      if ((curEl.val() == '' || curEl.val() == null)) {
        if (curEl.prop('nodeName') == 'SELECT') {
          $(val)
            .addClass('is-invalid')
            .parent()
            .addClass('is-invalid')

        } else {
          $(val)
            .parent()
            .addClass('validate')

          $(val)
            .addClass('is-invalid')
        }

        curErr++
      } else {
        $(val)
          .removeClass('is-invalid')

        $(val)
          .parent()
          .removeClass('is-invalid')
      }
    }
  })

  return curErr
}


/**
 * Setup Sweetalert loader
 */
const showLoader = () => {
  Swal.fire({
    title: 'Please Wait',
    allowOutsideClick: false,
    onBeforeOpen: () => {
      Swal.showLoading(); // Show the loader (older syntax)
    },
  });
};

const closeLoader = () => {
  Swal.close();
};
/**
 * EoL Sweetalert Loader
 */

function capitalizeString(val) {
  const formattedString = val.replace('  ', ' ');

  let curString = formattedString.split(' ');

  if (curString.length == 0) {
    return val;
  } else if (curString.length == 1) {
    return curString[0][0].toUpperCase() + curString[0].substring(1);
  } else {
    for (let i = 0; i < curString.length; i++) {
      curString[i] = curString[i][0].toUpperCase() + curString[i].substring(1);
    }

    curString.join(' ');

    return curString.toString().replace(/,/g, ' ');
  }
}

const parseJsonString = function (string, method) {
  let curString = '';

  try {
    if (string === '' || string === null || string === undefined) {
      return '';
    } else {
      if (method === 'encode') {
        curString = string.replace(/"/g, '&quot;');
      } else if (method === 'decode') {
        curString = JSON.parse(string.replace(/&quot;/g, '"'));
      }

      return curString;
    }
  } catch (ex) {
    console.log('something went wrong with', ex);
    console.log('current string', string);
  }
};

const customStorage = (function () {
  return {
    getItem: function (key) {
      // getting the data from localStorage using the key
      let result = JSON.parse(window.localStorage.getItem(key));

      if (result) {
        /*
                    if data expireTime is less then current time
                    means item has expired,
                    in this case removing the item using the key
                    and return the null.
                */
        if (result.expireTime <= Date.now()) {
          window.localStorage.removeItem(key);
          return null;
        }
        // else return the data.
        return result.data;
      }
      //if there is no data provided the key, return null.
      return null;
    },
    setItem: function (key, value, maxAge = 30 * 30 * 60 * 1000) {
      // Storing the value in object.
      let result = {
        data: value,
      };

      if (maxAge) {
        /*
                    setting the expireTime currentTime + expiry Time 
                    provided when method was called.
                */
        result.expireTime = Date.now() + maxAge;
      }
      window.localStorage.setItem(key, JSON.stringify(result));
    },
    removeItem: function (key) {
      window.localStorage.removeItem(key);
    },
    clear: function () {
      window.localStorage.clear();
    },
  };
})();

function checkEmptyString(str) {
  if (str == '' || str == '-' || str == null) {
    return '-';
  } else {
    return str;
  }
}

function buttonLoader(curEl, status, text = null) {
  if (status == 'loading') {
    curEl.html('Please Wait...').addClass('spinner spinner-white spinner-right').attr('disabled', true);
  } else if (status == 'failed' || status == 'finished') {
    curEl.html(text).removeClass('spinner spinner-white spinner-right').attr('disabled', false);
  }
}

function fileChangeListener($el, type = null) {
  $el.on('change', function (e) {
    //get the file name
    const fileName = e.target.files[0].name;

    if (type != 'MULTIPLE') {
      setTimeout(() => {
        if (fileName.length > 20) {
          $(this)
            .next('.custom-file-label')
            .html(fileName.substring(0, 17) + '...');
        } else {
          $(this).next('.custom-file-label').html(fileName);
        }
      }, 500);
    } else {
      setTimeout(() => {
        $(this)
          .next('.custom-file-label')
          .html(e.target.files.length + ' files selected');
      }, 500);
    }
  });
}

function dateFormatter(val, type = null) {
  const beginDate = new Date(val);
  let newDate;

  // let curIndex = (beginDate.getMonth() == 0 ? 0 : beginDate.getMonth()) - 1;
  const curIndex = beginDate.getMonth();

  // Helper untuk menambahkan nol di depan
  const addLeadingZero = (num) => String(num).padStart(2, '0');

  switch (type) {
    case 'SHORT':
      newDate = beginDate.getDate() + ' ' + shortenedMonth[curIndex < 0 ? 0 : curIndex] + ' ' + beginDate.getFullYear();
      break;

    case 'MONTH':
      newDate = month[curIndex < 0 ? 0 : curIndex] + ' ' + beginDate.getFullYear();
      break;

    case 'MONTH_SHORT':
      newDate = shortenedMonth[curIndex < 0 ? 0 : curIndex] + ' ' + beginDate.getFullYear();
      break;

    case 'YEAR':
      newDate = beginDate.getFullYear();
      break;

    case 'DATE':
      newDate = beginDate.getDate() + ' ' + month[curIndex < 0 ? 0 : curIndex];
      break;

    case 'TIME':
      // Ambil jam dan menit, lalu tambahkan leading zero
      const hours = addLeadingZero(beginDate.getHours());
      const minutes = addLeadingZero(beginDate.getMinutes());

      newDate = `${beginDate.getDate()} ${shortenedMonth[curIndex < 0 ? 0 : curIndex]} ${beginDate.getFullYear()} <strong>(${hours}:${minutes})</strong>`;
      break;

    default:
      newDate = beginDate.getDate() + ' ' + month[curIndex < 0 ? 0 : curIndex] + ' ' + beginDate.getFullYear();
      break;
  }

  let formattedDate;

  if (val == null || val == '0000-00-00') {
    formattedDate = '-';
  } else {
    formattedDate = newDate;
  }

  return formattedDate;
}

function getUrlParameter(sParam) {
  const sPageURL = window.location.search.substring(1)
  const sURLVariables = sPageURL.split('&')

  let sParameterName = ''
  let i = 0

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
}

const nl2br = (str, is_xhtml) => {
  var breakTag = is_xhtml || typeof is_xhtml === 'undefined' ? '<br />' : '<br>';
  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2');
};
const ucwords = (str) => {
  return (str + '').replace(/^([a-z])|\s+([a-z])/g, function ($1) {
    return $1.toUpperCase();
  });
};
const ucfirst = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};
const svgLoader = `
    <span class="svg-icon svg-icon-2x svg-icon-dark ml-3">
        <svg version="1.1" id="L7" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" enable-background="new 0 0 100 100" xml:space="preserve">
        <path fill="#fff" d="M31.6,3.5C5.9,13.6-6.6,42.7,3.5,68.4c10.1,25.7,39.2,38.3,64.9,28.1l-3.1-7.9c-21.3,8.4-45.4-2-53.8-23.3 c-8.4-21.3,2-45.4,23.3-53.8L31.6,3.5z">
            <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="2s" from="0 50 50" to="360 50 50" repeatCount="indefinite" />
        </path>
        <path fill="#fff" d="M42.3,39.6c5.7-4.3,13.9-3.1,18.1,2.7c4.3,5.7,3.1,13.9-2.7,18.1l4.1,5.5c8.8-6.5,10.6-19,4.1-27.7 c-6.5-8.8-19-10.6-27.7-4.1L42.3,39.6z">
            <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="1s" from="0 50 50" to="-360 50 50" repeatCount="indefinite" />
        </path>
        <path fill="#fff" d="M82,35.7C74.1,18,53.4,10.1,35.7,18S10.1,46.6,18,64.3l7.6-3.4c-6-13.5,0-29.3,13.5-35.3s29.3,0,35.3,13.5 L82,35.7z">
            <animateTransform attributeName="transform" attributeType="XML" type="rotate" dur="2s" from="0 50 50" to="360 50 50" repeatCount="indefinite" />
        </path>
        </svg>
    </span>
`;

const loadJSSVG = {
  whatsapp: `
        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 102 102">
            <defs>
                <linearGradient id="a" x1=".5" x2=".5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#61fd7d"/><stop offset="1" stop-color="#2bb826"/></linearGradient>
            </defs>
            <g transform="translate(.021 -.978)">
                <path fill="url(#a)" d="M101.971,77.094c0,.558-.017,1.77-.051,2.705a53.717,53.717,0,0,1-.538,6.589,21.949,21.949,0,0,1-1.847,5.521,19.654,19.654,0,0,1-8.653,8.644A21.993,21.993,0,0,1,85.33,102.4a53.913,53.913,0,0,1-6.539.528c-.936.033-2.148.05-2.7.05l-50.223-.008c-.558,0-1.769-.017-2.705-.051a53.744,53.744,0,0,1-6.589-.538,21.951,21.951,0,0,1-5.521-1.847A19.654,19.654,0,0,1,2.4,91.881,21.988,21.988,0,0,1,.557,86.329,53.954,53.954,0,0,1,.029,79.79c-.033-.936-.05-2.148-.05-2.7l.008-50.224c0-.558.017-1.77.051-2.705a53.738,53.738,0,0,1,.538-6.589,21.946,21.946,0,0,1,1.847-5.521A19.655,19.655,0,0,1,11.076,3.4a22,22,0,0,1,5.552-1.848,53.912,53.912,0,0,1,6.539-.528c.936-.033,2.148-.05,2.7-.05L76.095.986c.559,0,1.77.017,2.705.051a53.744,53.744,0,0,1,6.589.538A21.946,21.946,0,0,1,90.91,3.422a19.653,19.653,0,0,1,8.644,8.653,21.988,21.988,0,0,1,1.848,5.552,53.974,53.974,0,0,1,.528,6.539c.033.936.05,2.148.05,2.7l-.008,50.223Z" data-name="Path 19"/>
                <g data-name="Group 2">
                <path fill="#fff" d="M216,146.311a36.58,36.58,0,0,0-57.568,44.119l-5.189,18.948,19.39-5.085a36.561,36.561,0,0,0,17.479,4.451h.015A36.578,36.578,0,0,0,216,146.311ZM190.13,202.568h-.012a30.361,30.361,0,0,1-15.473-4.236l-1.11-.659-11.506,3.017,3.071-11.215-.723-1.15a30.4,30.4,0,1,1,25.754,14.242ZM206.8,179.807c-.914-.457-5.407-2.668-6.245-2.973s-1.447-.457-2.056.457-2.361,2.973-2.894,3.582-1.066.686-1.98.229a24.963,24.963,0,0,1-7.349-4.535,27.531,27.531,0,0,1-5.084-6.329c-.533-.915-.057-1.409.4-1.865.411-.409.914-1.067,1.371-1.6a6.23,6.23,0,0,0,.914-1.524,1.682,1.682,0,0,0-.076-1.6c-.228-.457-2.056-4.954-2.818-6.783-.742-1.782-1.5-1.541-2.056-1.568-.533-.027-1.142-.032-1.752-.032a3.358,3.358,0,0,0-2.437,1.143,10.246,10.246,0,0,0-3.2,7.622c0,4.5,3.275,8.841,3.732,9.451s6.444,9.838,15.612,13.8a52.582,52.582,0,0,0,5.21,1.925,12.535,12.535,0,0,0,5.756.362c1.756-.262,5.407-2.21,6.169-4.344a7.635,7.635,0,0,0,.533-4.344c-.229-.381-.838-.61-1.752-1.067Z" data-name="Path 20" transform="translate(-138.001 -121.202)"/>
                </g>
            </g>
        </svg>
    `,
  'whatsapp-sm': `
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 102 102">
            <defs>
                <linearGradient id="a" x1=".5" x2=".5" y2="1" gradientUnits="objectBoundingBox"><stop offset="0" stop-color="#61fd7d"/><stop offset="1" stop-color="#2bb826"/></linearGradient>
            </defs>
            <g transform="translate(.021 -.978)">
                <path fill="url(#a)" d="M101.971,77.094c0,.558-.017,1.77-.051,2.705a53.717,53.717,0,0,1-.538,6.589,21.949,21.949,0,0,1-1.847,5.521,19.654,19.654,0,0,1-8.653,8.644A21.993,21.993,0,0,1,85.33,102.4a53.913,53.913,0,0,1-6.539.528c-.936.033-2.148.05-2.7.05l-50.223-.008c-.558,0-1.769-.017-2.705-.051a53.744,53.744,0,0,1-6.589-.538,21.951,21.951,0,0,1-5.521-1.847A19.654,19.654,0,0,1,2.4,91.881,21.988,21.988,0,0,1,.557,86.329,53.954,53.954,0,0,1,.029,79.79c-.033-.936-.05-2.148-.05-2.7l.008-50.224c0-.558.017-1.77.051-2.705a53.738,53.738,0,0,1,.538-6.589,21.946,21.946,0,0,1,1.847-5.521A19.655,19.655,0,0,1,11.076,3.4a22,22,0,0,1,5.552-1.848,53.912,53.912,0,0,1,6.539-.528c.936-.033,2.148-.05,2.7-.05L76.095.986c.559,0,1.77.017,2.705.051a53.744,53.744,0,0,1,6.589.538A21.946,21.946,0,0,1,90.91,3.422a19.653,19.653,0,0,1,8.644,8.653,21.988,21.988,0,0,1,1.848,5.552,53.974,53.974,0,0,1,.528,6.539c.033.936.05,2.148.05,2.7l-.008,50.223Z" data-name="Path 19"/>
                <g data-name="Group 2">
                <path fill="#fff" d="M216,146.311a36.58,36.58,0,0,0-57.568,44.119l-5.189,18.948,19.39-5.085a36.561,36.561,0,0,0,17.479,4.451h.015A36.578,36.578,0,0,0,216,146.311ZM190.13,202.568h-.012a30.361,30.361,0,0,1-15.473-4.236l-1.11-.659-11.506,3.017,3.071-11.215-.723-1.15a30.4,30.4,0,1,1,25.754,14.242ZM206.8,179.807c-.914-.457-5.407-2.668-6.245-2.973s-1.447-.457-2.056.457-2.361,2.973-2.894,3.582-1.066.686-1.98.229a24.963,24.963,0,0,1-7.349-4.535,27.531,27.531,0,0,1-5.084-6.329c-.533-.915-.057-1.409.4-1.865.411-.409.914-1.067,1.371-1.6a6.23,6.23,0,0,0,.914-1.524,1.682,1.682,0,0,0-.076-1.6c-.228-.457-2.056-4.954-2.818-6.783-.742-1.782-1.5-1.541-2.056-1.568-.533-.027-1.142-.032-1.752-.032a3.358,3.358,0,0,0-2.437,1.143,10.246,10.246,0,0,0-3.2,7.622c0,4.5,3.275,8.841,3.732,9.451s6.444,9.838,15.612,13.8a52.582,52.582,0,0,0,5.21,1.925,12.535,12.535,0,0,0,5.756.362c1.756-.262,5.407-2.21,6.169-4.344a7.635,7.635,0,0,0,.533-4.344c-.229-.381-.838-.61-1.752-1.067Z" data-name="Path 20" transform="translate(-138.001 -121.202)"/>
                </g>
            </g>
        </svg>
    `,
  '3-dot': `
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="10" y="10" width="4" height="4" rx="2" fill="currentColor"></rect>
            <rect x="17" y="10" width="4" height="4" rx="2" fill="currentColor"></rect>
            <rect x="3" y="10" width="4" height="4" rx="2" fill="currentColor"></rect>
        </svg>
    `,
  task: `
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <rect x="0" y="0" width="24" height="24" />
            <path d="M10.5,5 L19.5,5 C20.3284271,5 21,5.67157288 21,6.5 C21,7.32842712 20.3284271,8 19.5,8 L10.5,8 C9.67157288,8 9,7.32842712 9,6.5 C9,5.67157288 9.67157288,5 10.5,5 Z M10.5,10 L19.5,10 C20.3284271,10 21,10.6715729 21,11.5 C21,12.3284271 20.3284271,13 19.5,13 L10.5,13 C9.67157288,13 9,12.3284271 9,11.5 C9,10.6715729 9.67157288,10 10.5,10 Z M10.5,15 L19.5,15 C20.3284271,15 21,15.6715729 21,16.5 C21,17.3284271 20.3284271,18 19.5,18 L10.5,18 C9.67157288,18 9,17.3284271 9,16.5 C9,15.6715729 9.67157288,15 10.5,15 Z" fill="#000000" />
            <path d="M5.5,8 C4.67157288,8 4,7.32842712 4,6.5 C4,5.67157288 4.67157288,5 5.5,5 C6.32842712,5 7,5.67157288 7,6.5 C7,7.32842712 6.32842712,8 5.5,8 Z M5.5,13 C4.67157288,13 4,12.3284271 4,11.5 C4,10.6715729 4.67157288,10 5.5,10 C6.32842712,10 7,10.6715729 7,11.5 C7,12.3284271 6.32842712,13 5.5,13 Z M5.5,18 C4.67157288,18 4,17.3284271 4,16.5 C4,15.6715729 4.67157288,15 5.5,15 C6.32842712,15 7,15.6715729 7,16.5 C7,17.3284271 6.32842712,18 5.5,18 Z" fill="#000000" opacity="0.3" />
            </g>
        </svg>
    `,
  edit: `
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <rect x="0" y="0" width="24" height="24"/>
                <path d="M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z" fill="#000000" opacity="0.3"/>
                <path d="M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z" fill="#000000"/>
                <rect fill="#000000" opacity="0.3" x="10" y="9" width="7" height="2" rx="1"/>
                <rect fill="#000000" opacity="0.3" x="7" y="9" width="2" height="2" rx="1"/>
                <rect fill="#000000" opacity="0.3" x="7" y="13" width="2" height="2" rx="1"/>
                <rect fill="#000000" opacity="0.3" x="10" y="13" width="7" height="2" rx="1"/>
                <rect fill="#000000" opacity="0.3" x="7" y="17" width="2" height="2" rx="1"/>
                <rect fill="#000000" opacity="0.3" x="10" y="17" width="7" height="2" rx="1"/>
            </g>
        </svg>
    `,
  checklist: `
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <polygon points="0 0 24 0 24 24 0 24"/>
                <path d="M9.26193932,16.6476484 C8.90425297,17.0684559 8.27315905,17.1196257 7.85235158,16.7619393 C7.43154411,16.404253 7.38037434,15.773159 7.73806068,15.3523516 L16.2380607,5.35235158 C16.6013618,4.92493855 17.2451015,4.87991302 17.6643638,5.25259068 L22.1643638,9.25259068 C22.5771466,9.6195087 22.6143273,10.2515811 22.2474093,10.6643638 C21.8804913,11.0771466 21.2484189,11.1143273 20.8356362,10.7474093 L17.0997854,7.42665306 L9.26193932,16.6476484 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" transform="translate(14.999995, 11.000002) rotate(-180.000000) translate(-14.999995, -11.000002) "/>
                <path d="M4.26193932,17.6476484 C3.90425297,18.0684559 3.27315905,18.1196257 2.85235158,17.7619393 C2.43154411,17.404253 2.38037434,16.773159 2.73806068,16.3523516 L11.2380607,6.35235158 C11.6013618,5.92493855 12.2451015,5.87991302 12.6643638,6.25259068 L17.1643638,10.2525907 C17.5771466,10.6195087 17.6143273,11.2515811 17.2474093,11.6643638 C16.8804913,12.0771466 16.2484189,12.1143273 15.8356362,11.7474093 L12.0997854,8.42665306 L4.26193932,17.6476484 Z" fill="#000000" fill-rule="nonzero" transform="translate(9.999995, 12.000002) rotate(-180.000000) translate(-9.999995, -12.000002) "/>
            </g>
        </svg >
    `,
  email: `
    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
      <title>Stockholm-icons / Communication / Mail</title>
      <desc>Created with Sketch.</desc>
      <defs/>
      <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <rect x="0" y="0" width="24" height="24"/>
          <path d="M5,6 L19,6 C20.1045695,6 21,6.8954305 21,8 L21,17 C21,18.1045695 20.1045695,19 19,19 L5,19 C3.8954305,19 3,18.1045695 3,17 L3,8 C3,6.8954305 3.8954305,6 5,6 Z M18.1444251,7.83964668 L12,11.1481833 L5.85557487,7.83964668 C5.4908718,7.6432681 5.03602525,7.77972206 4.83964668,8.14442513 C4.6432681,8.5091282 4.77972206,8.96397475 5.14442513,9.16035332 L11.6444251,12.6603533 C11.8664074,12.7798822 12.1335926,12.7798822 12.3555749,12.6603533 L18.8555749,9.16035332 C19.2202779,8.96397475 19.3567319,8.5091282 19.1603533,8.14442513 C18.9639747,7.77972206 18.5091282,7.6432681 18.1444251,7.83964668 Z" fill="#000000"/>
      </g>
    </svg>
  `,
};

const number_format = (value, currency) => {
  return new Intl.NumberFormat('id-ID', {
    ...(currency && {
      style: 'currency',
      currency: currency,
    }),
    maximumFractionDigits: 0,
  }).format(value);
};

const dtProcessing = {
  loadingRecords: `<div class= "d-flex flex-center"> Loading ${svgLoader}</div> `,
  processing: `<div class="d-flex flex-center"> Fetching Data ${svgLoader}</div > `,
};

const initDefaultSelect2 = (is_ajax = false, ajaxData = null, element, elementDropdownParent = undefined, placeholder = 'Choose', tags = false, allow_clear = false, is_search = true, searchValue = Infinity, isMultiple = false, customLanguage = null, isEscapeMarkup = false, templateResult = null, templateSelection = null) => {
  let defaultConfig = {
    placeholder: placeholder,
  };
  if (elementDropdownParent !== undefined) defaultConfig.dropdownParent = elementDropdownParent;
  // if (customCssClass !== undefined) defaultConfig.dropdownCssClass = customCssClass
  if (tags) defaultConfig.tags = true;
  if (allow_clear) defaultConfig.allowClear = true;
  if (!is_search) defaultConfig.minimumResultsForSearch = searchValue;
  if (isMultiple) defaultConfig.multiple = true;

  if (customLanguage !== undefined && customLanguage !== null) {
    if (customLanguage.show) {
      defaultConfig.language = {
        noResults: function () {
          return customLanguage.content;
        },
      };
    }
  }

  if (isEscapeMarkup)
    defaultConfig.escapeMarkup = function (markup) {
      return markup;
    };
  if (templateResult) defaultConfig.templateResult = templateResult;
  if (templateSelection) defaultConfig.templateSelection = templateSelection;

  if (is_ajax) {
    defaultConfig.ajax = {
      url: ajaxData.endpoint,
      dataType: 'json',
      type: 'POST',
      data: function (params) {
        let dataParams = {
          q: params.term,
          search: params.term,
          page: params.page || 1,
        };
        if (ajaxData.data) {
          dataParams = {
            ...dataParams,
            ...ajaxData.data,
          };
        }
        return dataParams;
      },
      delay: 1000,
    };
  }
  $(element).select2(defaultConfig);
};

var globalTypingTimer;
const globalDatatableSearch = (identifierDT, elementDT, globalDoneTypingInterval = 2000, tableID = null) => {
  let value = elementDT.target.value;
  clearTimeout(globalTypingTimer);
  if (value && value.length >= 3) {
    globalTypingTimer = setTimeout(() => {
      identifierDT.search(value).draw();
    }, globalDoneTypingInterval);
  } else {
    if (elementDT.keyCode == 8 || elementDT.keyCode == 46 || elementDT.keyCode === 13) {
      globalTypingTimer = setTimeout(() => {
        identifierDT.search(value).draw();
      }, globalDoneTypingInterval);
    }
  }

  if (tableID) {
    setTimeout(() => {
      makeKTBlock(tableID, 'hide');
    }, 1000);
  }
};

const ellipseText = (text, count, insertDots) => {
  return text.slice(0, count) + (text.length > count && insertDots ? '...' : '');
};

const splitable = (str, token) => {
  return (str || '').split(token).length > 1;
};

const makeSwal = (title, message, status, type = null, customWidth = null, redirect = null, outsideClickAble = true, contentDT = null) => {
  if (type == 'action') {
    Swal.fire({
      title: title,
      html: message,
      icon: status,
      confirmButtonText: 'Close',
      confirmButtonColor: '#3699FF',
      customClass: { confirmButton: 'btn btn-sm', cancelButton: 'btn btn-sm' },
      allowOutsideClick: outsideClickAble,
      width: customWidth ? customWidth : 'auto',
    }).then((result) => {
      if (redirect == 'reload') {
        location.reload();
      } else if (redirect == 'reload-dt') {
        contentDT.ajax.reload();
      } else if (redirect == 'reload-kdt') {
        $(contentDT).KTDatatable('reload');
      } else if (redirect && redirect.startsWith('reload-tab#')) {
        const tabId = redirect.replace('reload-tab#', '');
        window.location.hash = tabId;
        location.reload();
      } else {
        window.location.href = redirect;
      }
    });
  } else {
    Swal.fire({
      title: title,
      html: message,
      icon: status,
      confirmButtonText: 'Close',
      confirmButtonColor: '#3699FF',
      customClass: {
        confirmButton: 'btn btn-sm',
      },
    });
  }
};

const makeNotify = (title, message, status, position = 'bottom', align = 'right', showDuration = 300, hideDuration = 1000, timeOut = 5000, extendedTimeOut = 1000) => {
  let positionClass = 'toast-' + position + '-' + align;
  toastr.options = {
    closeButton: true,
    debug: false,
    newestOnTop: true,
    progressBar: false,
    positionClass: positionClass,
    preventDuplicates: false,
    onclick: null,
    showDuration: showDuration,
    hideDuration: hideDuration,
    timeOut: timeOut,
    extendedTimeOut: extendedTimeOut,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'fadeOut',
  };

  if (status == 'success') {
    toastr.success(message, title);
  } else if (status == 'info') {
    toastr.info(message, title);
  } else if (status == 'warning') {
    toastr.warning(message, title);
  } else {
    toastr.error(message, title);
  }
};

const arrayUnique = (value, index, array) => {
  return array.indexOf(value) === index;
};

const makeKTBlock = (element, type = 'show', bgColor = '#000') => {
  if (type == 'show') {
    KTApp.block(element, {
      overlayColor: bgColor,
      type: 'loader',
      state: 'primary',
      opacity: 0.3,
      size: 'lg',
      message: 'Please wait...',
    });
  } else {
    KTApp.unblock(element);
  }
};

const randomInteger = (max) => {
  return Math.floor(Math.random() * (max + 1));
};

const randomRGBColor = () => {
  let r = randomInteger(255);
  let g = randomInteger(255);
  let b = randomInteger(255);
  return [r, g, b];
};

const randomHEXColor = () => {
  let [r, g, b] = randomRGBColor();
  let hr = r.toString(16).padStart(2, '0');
  let hg = g.toString(16).padStart(2, '0');
  let hb = b.toString(16).padStart(2, '0');
  return '#' + hr + hg + hb;
};

const generateHexColor = (total) => {
  let $arr = [];
  for (let index = 0; index < total; index++) {
    $arr.push(randomHEXColor());
  }
  return $arr;
};

const shuffleArray = (array) => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

const primary = '#009EF7',
  info = '#7239EA',
  warning = '#FFC700',
  danger = '#F1416C',
  success = '#50CD89',
  dark = '#181C32',
  teal = '#008080',
  navy = '#000080',
  fuchsia = '#FF00FF',
  gray = '#808080',
  brown = '#a52a2a',
  crimson = '#ed143d',
  forestgreen = '#228b22';

const colorPalette = [primary, info, warning, danger, success, teal, navy, fuchsia, gray, brown, crimson, forestgreen, dark];

const generateColorPalette = () => {
  return shuffleArray(colorPalette);
};

function countObjectKeys(obj) {
  return Object.keys(obj).length;
}

const escapeHtml = (html) => {
  return html.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#039;');
};

function removeTags(str) {
  if (str === null || str === '') return false;
  else str = str.toString();

  // Regular expression to identify HTML tags in
  // the input string. Replacing the identified
  // HTML tag with a null string.
  return str.replace(/(<([^>]+)>)/gi, '\n');
}

function removeAllAttributes(htmlString) {
  // Parse the HTML string into a DOM document
  var parser = new DOMParser();
  var doc = parser.parseFromString(htmlString, 'text/html');

  // Iterate over all elements and remove their attributes
  doc.body.querySelectorAll('*').forEach(function (element) {
    // Get a list of attributes and remove each one
    var attributes = element.getAttributeNames();
    attributes.forEach(function (attr) {
      element.removeAttribute(attr);
    });
  });

  // Serialize the document back to a string and return it
  return doc.body.innerHTML;
}

const getIDSelected = (selectedRecords, idx) => {
  let idArr = [];

  if (selectedRecords.length) {
    for (let i = 0; i < selectedRecords.length; i++) {
      let curRow = $(selectedRecords[i]).children(`[data - field="${idx}"]`);
      let curID = $(curRow).attr('aria-label');
      idArr.push(curID);
    }
  }

  return idArr;
};

const encryptNIP = (nip) => {
  return CryptoJS.SHA256(nip).toString(CryptoJS.enc.Hex);
};

const secretKeyEncrypt = 'ICAN99';
const encryptData = (data) => {
  return CryptoJS.AES.encrypt(data, secretKeyEncrypt).toString();
};

const decryptData = (encryptedData, isJSON) => {
  const bytes = CryptoJS.AES.decrypt(encryptedData, secretKeyEncrypt);

  return isJSON ? JSON.parse(bytes.toString(CryptoJS.enc.Utf8)) : bytes.toString(CryptoJS.enc.Utf8);
};

const numberFormatPrefix = (amount, locale = 'id-ID', currency = 'IDR', decimal = 0) => {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: decimal, // No decimals for Rupiah
  }).format(amount);
};

const isUrl = (value) => {
  try {
    new URL(value);
    return true;
  } catch (_) {
    return false;
  }
};

export { manualValidation, capitalizeString, parseJsonString, encryptNIP, encryptData, decryptData, numberFormatPrefix, dateFormatter, getUrlParameter, buttonLoader, checkEmptyString, fileChangeListener, nl2br, ucwords, ucfirst, svgLoader, number_format, dtProcessing, initDefaultSelect2, globalDatatableSearch, ellipseText, splitable, makeSwal, makeNotify, arrayUnique, makeKTBlock, randomRGBColor, randomHEXColor, generateHexColor, shuffleArray, generateColorPalette, countObjectKeys, loadJSSVG, customStorage, escapeHtml, removeTags, removeAllAttributes, getIDSelected, showLoader, closeLoader, isUrl };
